"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
/**
 * Scope method to data.
 *
 * @param {Object} data Dataset.
 * @returns {Function} Getter.
 * @api public
 */
function get() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  /**
   * Get property from data, fallback to lowercased or uppercased.
   *
   * @param {String} property Name.
   * @param {Boolean} fallback Return property name if no value was found.
   * @returns {Mixed} property value.
   * @api private
   */
  return function propGet(property, fallback) {
    const result = data[property] || data[property.toLowerCase()] || data[property.toUpperCase()];
    return !fallback ? result : result || property;
  };
}